export default "__VITE_ASSET__CneavYfh__"